import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconOutlinedUpload = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.333 8.33301C13.7012 8.33301 14 8.63181 14 9V13C13.9999 13.7362 13.4032 14.3328 12.667 14.333H3.33301C2.59682 14.3328 2.00007 13.7362 2 13V9C2 8.63181 2.2988 8.33301 2.66699 8.33301C3.03503 8.33318 3.33301 8.63192 3.33301 9V13H12.667V9C12.667 8.63192 12.965 8.33318 13.333 8.33301ZM7.52832 1.86133C7.78864 1.60111 8.21136 1.60111 8.47168 1.86133L11.8047 5.19531C12.0649 5.45563 12.0649 5.87736 11.8047 6.1377C11.5444 6.39802 11.1227 6.39798 10.8623 6.1377L8.66699 3.94238V11C8.66692 11.3681 8.36815 11.667 8 11.667C7.63185 11.667 7.33308 11.3681 7.33301 11V3.94238L5.1377 6.1377C4.87734 6.39798 4.45564 6.39802 4.19531 6.1377C3.93508 5.87736 3.93506 5.45563 4.19531 5.19531L7.52832 1.86133Z",
		fill: "#959595"
	})
});
export default SvgIconOutlinedUpload;
